import { StatusBadge } from 'app/concierge/types';
import { Box, CircularProgress, Stack } from '@mui/material';
import parse from 'html-react-parser';
import React from 'react';

export default function JsonStatusBadge({ statusBadge }: { statusBadge: StatusBadge }) {
    return (
        <Stack direction={'row'} justifyContent={'space-between'}>
            <Box>{parse(statusBadge.title)}</Box>
            <Box>
                <CircularProgress size={16} />
            </Box>
        </Stack>
    );
}
